// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__B6P-l","imageContainer":"ImageSection_imageContainer__d2YZr","logo":"ImageSection_logo__fKhu3","cover":"ImageSection_cover__s-6Gf"};